import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Button, Flex } from 'core/ui/atoms';

import { editWeekMenuPath } from 'onramp/api/navigation';
import { GET_PROGRAM_DETAIL } from 'core/api/apollo/queries';
import Loading from 'core/ui/components/Loading';
import { isLoading } from 'core/api/loadingHelpers';

const EditWeekOrder = ({ deliveryPeriodId }) => {
  const history = useHistory();

  const { loading, data: { getProgramDetail = {} } = {} } = useQuery(GET_PROGRAM_DETAIL);

  const onEditWeekMenu = () => {
    history.push(editWeekMenuPath(deliveryPeriodId));
  };

  if (isLoading(loading, getProgramDetail)) {
    return <Loading />;
  }

  return (
    <EditWeekOrderBottom>
      <EditOrderButton onClick={onEditWeekMenu}>EDIT MY ORDER</EditOrderButton>
    </EditWeekOrderBottom>
  );
};

EditWeekOrder.propTypes = {
  deliveryPeriodId: PropTypes.string.isRequired,
};

const EditWeekOrderBottom = styled(Flex)`
  ${(p) => p.theme.max('sm')`
    display: flex;
    justify-content: center;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 20px;
    background-color: ${(p) => p.theme.colors.creamWhite};
    height: 80px;
  `}
`;

const EditOrderButton = styled(Button)`
  padding: 12px 10px;
  border-radius: 4px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: ${(p) => p.theme.colors.green.light};
  ${(p) => p.theme.max('sm')`
    margin-bottom: 0;
    width: 85%;
  `}
`;

export default EditWeekOrder;
